import { ReactComponent as mLogo } from "./logo/logo.svg";
import pray1 from "./login/Pray-amico.svg";
import pray2 from "./login/Pray-cuate.svg";
import pray3 from "./login/Pray-rafiki.svg";

// Login Slider
export const Pray1 = pray1;
export const Pray2 = pray2;
export const Pray3 = pray3;

// Logo
export const LogoSVG = mLogo;